"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Presets = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _format = require("./format.js");

var PatternPresets = _interopRequireWildcard(require("./presets.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NOOP = function NOOP() {};

var Presets = PatternPresets;
exports.Presets = Presets;
var PROPS_TO_EXCLUDE = ["element", "value", "onChange"];

var FormattedInput =
/*#__PURE__*/
function (_Component) {
  _inherits(FormattedInput, _Component);

  function FormattedInput(props) {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FormattedInput);

    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FormattedInput)).call.apply(_getPrototypeOf2, [this, props].concat(rest))); // format the provided value immediately

    var _formatValue = (0, _format.formatValue)(props.value, _this.getFormat(props)),
        formatted = _formatValue.formatted,
        raw = _formatValue.raw;

    _this.state = {
      rawValue: raw,
      formattedValue: formatted
    };
    return _this;
  }

  _createClass(FormattedInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.value !== this.props.value) {
        var _formatValue2 = (0, _format.formatValue)(this.props.value, this.getFormat(this.props)),
            formattedValue = _formatValue2.formatted,
            rawValue = _formatValue2.raw;

        this.setState({
          formattedValue: formattedValue,
          rawValue: rawValue
        });
      } else if (prevState.formattedValue !== this.state.formattedValue) {
        // only fire callback if the value changes
        this.props.onChange(this.state.formattedValue, this.state.rawValue);
      }
    }
  }, {
    key: "getFormat",
    value: function getFormat() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      return this.inputType === "password" ? [] : props.format;
    }
    /**
     * Fetch optional pass-through props for the underlying input
     * @returns {Object} A props object to be spread onto the input
     */

  }, {
    key: "getOptionalProps",
    value: function getOptionalProps() {
      var _this2 = this;

      return Object.keys(this.props).reduce(function (props, propName) {
        if (PROPS_TO_EXCLUDE.indexOf(propName) === -1) {
          return _objectSpread({}, props, _defineProperty({}, propName, _this2.props[propName]));
        }

        return props;
      }, {});
    }
    /**
     * Handle value changes
     * @param {Object} event An input change event
     */

  }, {
    key: "onValueChange",
    value: function onValueChange(event) {
      var inputValue = event.target.value;

      var _formatValue3 = (0, _format.formatValue)(inputValue, this.getFormat()),
          formatted = _formatValue3.formatted,
          raw = _formatValue3.raw;

      this.setState({
        rawValue: raw,
        formattedValue: formatted
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var Element = this.props.element;
      return _react.default.createElement(Element, _extends({
        type: this.inputType
      }, this.getOptionalProps(), {
        value: this.state.formattedValue,
        onChange: function onChange(e) {
          return _this3.onValueChange(e);
        }
      }));
    }
  }, {
    key: "inputType",
    get: function get() {
      if (this.props.type === "password") {
        return "password";
      }

      return "text";
    }
  }]);

  return FormattedInput;
}(_react.Component);

exports.default = FormattedInput;

_defineProperty(FormattedInput, "propTypes", {
  element: _propTypes.default.elementType.isRequired,
  format: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  onChange: _propTypes.default.func.isRequired,
  type: _propTypes.default.string.isRequired,
  value: _propTypes.default.string.isRequired
});

_defineProperty(FormattedInput, "defaultProps", {
  element: "input",
  format: [],
  onChange: NOOP,
  type: "text",
  value: ""
});